"use strict";
const _ = require("lodash");
const arrayutils_1 = require("arrayutils");
const similarity_1 = require("./similarity");
var TRACES;
(function (TRACES) {
    TRACES[TRACES["DIAGONAL"] = 0] = "DIAGONAL";
    TRACES[TRACES["UP"] = 1] = "UP";
    TRACES[TRACES["LEFT"] = 2] = "LEFT";
    TRACES[TRACES["NONE"] = 3] = "NONE";
})(TRACES = exports.TRACES || (exports.TRACES = {}));
class SmithWaterman {
    //if similarity threshold is null, equality is enforced
    constructor(similarityTreshold) {
        this.similarityTreshold = similarityTreshold;
        this.matchScore = 3;
        this.mismatchScore = -2;
        this.gapScore = -1;
    }
    run(seq1, seq2, ignoredPoints) {
        if (!ignoredPoints) {
            ignoredPoints = [];
        }
        //ignore diagonal if sequences equal
        if (_.isEqual(seq1, seq2)) {
            ignoredPoints.push(...seq1.map((e, i) => [i, i]));
        }
        let ignoredPointStrings = ignoredPoints.map(p => JSON.stringify(p)).map(p => p.slice(1, p.length - 1));
        return this.internalRun(seq1, seq2, ignoredPointStrings);
    }
    internalRun(seq1, seq2, ignoredPoints) {
        let scoreMatrix = seq1.map(s => seq2.map(t => 0));
        let traceMatrix = seq1.map(s => seq2.map(t => 0));
        seq1.forEach((s1, i) => {
            seq2.forEach((s2, j) => {
                if (i == 0 || j == 0) {
                    traceMatrix[i][j] = 3;
                }
                else {
                    let d_last = scoreMatrix[i - 1][j - 1];
                    let u_last = scoreMatrix[i - 1][j];
                    let l_last = scoreMatrix[i][j - 1];
                    //here we don't give scores for self alignment!! hence i != j
                    let notIgnored = ignoredPoints.indexOf(i + "," + j) < 0;
                    let d_new = d_last + (notIgnored && this.isSimilar(s1, s2) ? this.matchScore : this.mismatchScore);
                    let u_new = u_last + this.gapScore;
                    let l_new = l_last + this.gapScore;
                    let options = [d_new, u_new, l_new, 0];
                    scoreMatrix[i][j] = _.max(options);
                    let trace = arrayutils_1.indexOfMax(options);
                    traceMatrix[i][j] = trace;
                }
            });
        });
        //console.log(JSON.stringify(scoreMatrix))
        return { scoreMatrix: scoreMatrix, traceMatrix: traceMatrix };
    }
    isSimilar(v1, v2) {
        return (this.similarityTreshold != null && similarity_1.Similarity.getCosineSimilarity(v1, v2) > this.similarityTreshold)
            || _.isEqual(v1, v2);
    }
}
exports.SmithWaterman = SmithWaterman;



//////////////////
// WEBPACK FOOTER
// ./~/siafun/lib/smith-waterman.js
// module id = 823
// module chunks = 3